import {css, useTheme} from '@mui/material';
import {
  DlMuiDynamicIcon,
  DlMuiTypography,
  GetStylesFunction,
} from '@wallaby-ui/core';
import * as React from 'react';

interface OwnProps {
  handleOnMouseEnter: () => void;
  handleOnMouseLeave: () => void;
  label: string;
}

type Props = OwnProps;

export const EditableField: React.FC<Props> = (props) => {
  const {children, handleOnMouseEnter, handleOnMouseLeave, label} = props;
  const theme = useTheme();
  const styles = getStyles({theme});

  return (
    <div
      css={styles.editableField}
      onMouseEnter={handleOnMouseEnter}
      onMouseLeave={handleOnMouseLeave}
    >
      <DlMuiTypography variant={'label'} value={label} />
      {children}
    </div>
  );
};

EditableField.displayName = 'EditableField';

const getStyles: GetStylesFunction = (options) => ({
  editableField: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${options?.theme?.spacing(1, 4)};
    width: 100%;
    height: 100%;
    gap: ${options?.theme?.spacing(1)};
    flex: 0.5;

    &:hover {
      background-color: ${options?.theme?.palette.custom.coolGray['50']};
      border-radius: ${options?.theme?.spacing(4)};
    }
  `,
});
